/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { MixNavigator } from './MixNavigator';
/**
 * factory to build a mixnavigator
 */
export class MixNavigatorFactory {
    /**
     * constructor
     * @param factories factories of the Navigators to use
     */
    constructor(...factories) {
        this._factories = factories;
    }
    /**
     * builds a navigator adapter
     * @param camera the camera to manipulate
     * @param scene the scene (e.g. for scanning)
     */
    build(camera, scene) {
        const arr = new Array();
        this._factories.forEach((factory) => { arr.push(factory.build(camera, scene)); });
        return new MixNavigator(arr);
    }
}
//# sourceMappingURL=MixNavigatorFactory.js.map